// extracted by mini-css-extract-plugin
export default {"card":"q2-z"};